var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"align-items":"center","display":"flex"}},[_c('el-icon',{staticClass:"el-icon-s-home"}),_vm._v("     "),_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumblist),function(item){return _c('el-breadcrumb-item',{key:item.name},[_c('span',[_vm._v(_vm._s(item.name))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }